import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { deepCopy, isDeepEqual, isNullOrUndefinedOrEmpty } from '../../../util/Utils'
import useNotifications from '../../../hooks/useNotifications'
import {
  convertDateString,
  dateStringToTimestamp,
  STANDARDS_DAY_MONTH_YEAR_FORMAT,
  STANDARDS_MONTH_YEAR_FORMAT,
  STANDARDS_YEAR_FORMAT,
  FORMAL_DATE_FORMAT,
} from '../../../util/DateUtil'

export default () => {}

export function useDmcDatePickerController(
  selectedItem,
  setSelectedItem,
  dayMonthYearDateFormat,
  monthYearDateFormat,
  yearDateFormat
) {
  const { t } = useTranslation()

  if (isNullOrUndefinedOrEmpty(monthYearDateFormat)) {
    monthYearDateFormat = dayMonthYearDateFormat
  }
  if (isNullOrUndefinedOrEmpty(yearDateFormat)) {
    yearDateFormat = dayMonthYearDateFormat
  }

  const notifications = useNotifications()

  const datePickerModel = {
    selectedItem,
  }

  const datePickerActions = {
    setNewSelectedItem: (n) => {
      const newSelectedItem = {
        key: n?.standard?.formalText || n?.standard?.originalText || 'date',
        primaryText: n?.standard?.standardizedText || '',
        formal: n?.standard?.formalText || '',
        original: n?.standard?.originalText || '',
      }

      if (!isDeepEqual(datePickerModel.selectedItem, newSelectedItem)) {
        if (!isNullOrUndefinedOrEmpty(newSelectedItem?.primaryText)) {
          const formalTextAsTimestamp = dateStringToTimestamp(newSelectedItem?.formal, FORMAL_DATE_FORMAT)
          let formattedDate
          const itemsCount = newSelectedItem?.formal?.split('-').length
          if (itemsCount === 3) {
            formattedDate = moment(formalTextAsTimestamp).format(dayMonthYearDateFormat)
          } else if (itemsCount === 2) {
            formattedDate = moment(formalTextAsTimestamp).format(monthYearDateFormat)
          } else if (itemsCount === 1) {
            formattedDate = moment(formalTextAsTimestamp).format(yearDateFormat)
          }

          if (isNullOrUndefinedOrEmpty(formattedDate) || formattedDate === t('invalid.date', 'Invalid date')) {
            const invalidDate = newSelectedItem?.primaryText
            notifications.error(
              t('errors.invalidDate', {
                defaultValue: `Invalid Date: ${invalidDate}`,
                date: invalidDate,
              })
            )
          } else {
            newSelectedItem.formattedDate = formattedDate
            setSelectedItem(newSelectedItem)
          }
          return formattedDate
        }

        setSelectedItem(newSelectedItem)
      }
      return ''
    },
  }

  return { datePickerModel, datePickerActions }
}

export function initDatePicker(formattedDate, dayMonthYearDateFormat, monthYearDateFormat, yearDateFormat) {
  if (isNullOrUndefinedOrEmpty(formattedDate)) {
    return undefined
  }

  // set defaults
  if (isNullOrUndefinedOrEmpty(monthYearDateFormat)) {
    monthYearDateFormat = dayMonthYearDateFormat
  }
  if (isNullOrUndefinedOrEmpty(yearDateFormat)) {
    yearDateFormat = dayMonthYearDateFormat
  }

  // try parsing the formattedDate to get the date that we will display in the textbox of dateSuggest
  let displayStandardsDate

  if (dayMonthYearDateFormat !== yearDateFormat && formattedDate.length === yearDateFormat.length) {
    displayStandardsDate = convertDateString(formattedDate, yearDateFormat, STANDARDS_YEAR_FORMAT)
  } else if (dayMonthYearDateFormat !== monthYearDateFormat && formattedDate.length === monthYearDateFormat.length) {
    displayStandardsDate = convertDateString(formattedDate, monthYearDateFormat, STANDARDS_MONTH_YEAR_FORMAT)
  } else {
    displayStandardsDate = convertDateString(formattedDate, dayMonthYearDateFormat, STANDARDS_DAY_MONTH_YEAR_FORMAT)
  }
  const date = {
    original: formattedDate,
    formal: '',
    primaryText: displayStandardsDate,
    formattedDate,
  }
  return deepCopy(date)
}
